import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { DialogModalComponent } from './dialog-modal.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    DialogModalComponent
  ],
  entryComponents: [
    DialogModalComponent
  ],
  exports: [
    DialogModalComponent
  ]
})
export class DialogModalModule {
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/dialog-modal/dialog-modal.module.ts